<template>
  <div>
    <LeftListSupplier :pos="3"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="/supplier-equity" class="txt">会员权益</router-link>
          </li>
          <li class="li">
            <router-link to="/info-recharge" class="txt">在线购买</router-link>
          </li>
          <li class="li">
            <router-link to="/info-record" class="txt">交易记录</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox5">
            <div class="box1">
              <img src="@/assets/images/icon1.png" class="icon" alt="" />
              <div class="tit" @click="protocol.show=true" style="cursor: pointer;">《企业VIP服务协议》</div>
            </div>
            <div class="box4">
              <router-link to="/info-recharge" class="link">开通/续费企业VIP</router-link>
              <router-link to="/info-recharge" class="link link2">数据下载套餐购买</router-link>
            </div>
            <div class="box2">
              <div class="inner" v-if="isVip">
                  <div class="left">
                    <img src="@/assets/images/icon2.png" class="icon" alt="" />
                    <div class="tit">
                      会员VIP有效期：<span>{{ userInfo.vipTime.split(' ')[0] }}</span>
                    </div>
                    <div class="tit" style="margin-left: 100px;">
                      数据下载剩余：
                      <div v-if="userInfo.isDownloadUnlimit==1" style="display: inline-block;"><span>无限制</span></div>
                      <div v-else style="display: inline-block;"><span>{{ userInfo.downloadNumLeft }}</span>条</div>
                    </div>
                  </div>
<!--                  <div class="left">-->
<!--                    <div class="tit">-->
<!--                      数据下载剩余：<span>80000</span>条-->
<!--                    </div>-->
<!--                  </div>-->
               </div>
              <div class="right" v-else>您还未开通企业VIP权限</div>
            </div>
            <div class="box3">
              <div class="top">
                <div class="tit">会员权益</div>
              </div>
              <div class="txt" v-html="$store.state.config.bk_supplier_vip_description">
<!--                <div class="p">1，目录库管理，上传图书目录（统一固定格式），支持分批上传，可对图书目录进行查删修改，统一上调和下降折扣，可一键清空书目库；</div>-->
<!--                <div class="p">2，订单管理，接处到的用户订定，显示用户信息，图书信息等；已处理与未处理订单进行管理；</div>-->
<!--                <div class="p">3，一个公司账号下可管理多少员工账号</div>-->
<!--                <div class="p">4、在线选书，为客户创建专属图书目录</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <protocol-dialog :show.sync="protocol.show" :type="protocol.type"></protocol-dialog>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import ProtocolDialog from "@/components/ProtocolDialog.vue";
import dayjs from 'dayjs'
export default {
  components: {
    ProtocolDialog,
    LeftListSupplier,
  },
  data() {
    return {
      protocol: {
        type:'bk_supplier_vip',
        show: false
      }
    }
  },
  computed: {
    userInfo(){
      return this.$store.state.user.userInfo
    },
    isVip(){
      return dayjs(this.$store.state.user.userInfo.vipTime).unix() > dayjs().unix()
    }
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
